module.exports = __webpack_public_path__ + "static/LEadgenperformance-5f01b53d09bb78308c55e03f40baf70d.png";